<script>
  import Lenke from './lenke.svelte'
  import { isFullWidth } from './util'
  import { fade } from 'svelte/transition'
  import { cols } from '@/stores/cols'
  import { currentRoute } from '../../stores/router'
  export let lenker
  export let trackingId

  $: computed = lenker.reduce(
    (res, lnk) => {
      const lenke = { ...lnk }
      const size = lenke.visning === 'vertikal-enkel' ? 1 : 2
      res.pos += size
      const row = Math.floor(res.pos / $cols)
      lenke.delay = 300 + row * 50
      res.lenker.push(lenke)

      return res
    },
    { lenker: [], pos: -1 }
  )
</script>

<style>
  .grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: auto;

    padding: 0;
    margin-top: 10px;
  }

  .lenke {
    list-style: none;
    background: white;
    border-radius: 6px;
  }

  .full-width {
    grid-column: 2 span;
  }

  @media (min-width: 600px) {
    .grid {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-auto-rows: auto;
    }
  }
</style>

<ul class="grid" data-ec-list={trackingId}>
  {#each computed.lenker as lenke (lenke.id)}
    {#key `${lenke.id} ${$currentRoute.params.slug}`}
      <li
        class="lenke"
        class:full-width={isFullWidth(lenke)}
        data-delay={lenke.delay}
        in:fade={{ duration: 300, delay: lenke.delay }}
        out:fade={{ duration: 200 }}>
        <Lenke {lenke} />
      </li>
    {/key}
  {/each}
</ul>
